import React, { useRef } from 'react';
import qs from 'qs';

export default function useQueryParamsOnload() {
  const { current } = useRef(qs.parse(window.location.search?.slice(1)));
  return current;
}
